import LayoutStatic from "@/layouts/LayoutStatic/LayoutStatic.vue";
import CMSService from "@/services/CMSService.js";

export default {
    components: {
        LayoutStatic
    },
    data() {
        return {
            layout: LayoutStatic,
            pageTitle: "",
            pageContent: ""
        };
    },
    metaInfo() {
        return {
            title: `Condiciones de uso de YourDictionary`,
            meta: [
                {
                    name: "description",
                    content: `Página de las condiciones de uso de YourDictionary`
                }
            ]
        };
    },
    methods: {
        fetchContent() {
            CMSService.getCondicionesYDR().then(
                response => {
                    const data = response.data.data;
                    this.pageTitle = data.title;
                    this.pageContent = data.body;
                },
                err => {
                    this.status.err = true;
                }
            );
        }
    },
    mounted() {
        this.fetchContent();
    }
};



// WEBPACK FOOTER //
// ./src/pages/CondicionesDeUso/CondicionesDeUso.js